<template>
  <page-wrap>
    <layout :isEmpty="false">
      <template v-slot:header>
        <h1 class="page-title">{{pageTitle}}</h1>
      </template>
      <template v-slot:tools>
        <top-panel
          :orderBy.sync="orderBy"
          :displayActivityLog.sync="displayActivityLog"
        ></top-panel>
      </template>
      <template v-slot:content>
        <editor
          :orderBy="orderBy"
          :displayActivityLog="displayActivityLog"
        ></editor>
      </template>
    </layout>
  </page-wrap>
</template>

<script>
export default {
  name: 'RFQOpenWOIndex',
  components: {
    'page-wrap': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PageWrap'),
    'layout': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/PagePanel'),
    'top-panel': () => import(/* webpackChunkName: 'OpenWO' */ './TopPanel.vue'),
    'editor': () => import(/* webpackChunkName: 'OpenWO' */ './Editor.vue')
  },
  data () {
    return {
      displayActivityLog: true,
      orderBy: 1
    }
  },
  computed: {
    pageTitle () {
      return this.L10n(this.$route.meta.label)
    }
  }
}
</script>
